import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  Grid,
  Typography
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ApiDeleteReportMessage,
  ApiGetRegionBusinessDetails,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";

const RegionBusinessDetails: React.FC = () => {
  const [regionBusinessDetail, setRegionBusinessDetails] = useState([]);

  const fetchRegionBusinessDetails = async () => {
    try {
      const response = await ApiGetRegionBusinessDetails();
      setRegionBusinessDetails(response.data);
    } catch (error) {
      console.error("Error fetching area managers:", error);
    }
  };

  useEffect(() => {
    fetchRegionBusinessDetails();
  }, []);

  const navigate = useNavigate();

  const addOrUpdateRegionBusinessDetails = (reportBusinessDetails?: any) => {
    if (reportBusinessDetails) {
      navigate(
        `/admin/add-or-update-regionBusinessDetail/update/${reportBusinessDetails.clientEntityRegionReportId}`,
        {
          state: { reportBusinessDetails: reportBusinessDetails },
        }
      );
    } else {
      navigate("/admin/add-or-update-regionBusinessDetail/add");
    }
  };

  const handleDelete = async (clientEntityRegionReportId: number) => {
    const data = `?clientEntityRegionReportId=${clientEntityRegionReportId}`;
    try {
      const response = await ApiDeleteReportMessage(data);
      toast.success("Report Message deleted successfully");
      fetchRegionBusinessDetails();
    } catch (error) {
      console.error("Error deleting brief:", error);
      toast.error("Failed to delete brief");
    }
  };

  return (
    <div className="w-100 p-3">
      <Box className='bg-white border-10 w-100 p-3'>
        <Grid container className="w-100 align-items-center mb-5" gap={3}>
          <Grid size={{ xs: 12, md: "grow" }}>
            <Typography className="fs-42 text-center">Region Business Details</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: "auto" }}>
            <div className="add-button">
              <Link
                to={'/admin/add-or-update-regionBusinessDetail/add'}
                className="table-row-background link-btn"
              >
                Add Region Business Detail
              </Link>
              {/* <Button
                variant="contained"
                onClick={() => addOrUpdateRegionBusinessDetails()}
                className="table-row-background"
              >
                Add Region Business Detail
              </Button> */}
            </div>
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {["", "Region", "Business", ""].map((item) => (
                  <TableCell style={{ color: "#fff" }}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {regionBusinessDetail.map((details: any) => (
                <TableRow key={details?.clientEntityRegionReportId}>
                  <TableCell>
                    <Button
                      variant="contained"
                      className="delete-transparent"
                      onClick={() => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete?"
                        );
                        if (isConfirmed) {
                          handleDelete(details?.clientEntityRegionReportId); // Call the API or action
                        }
                      }}
                    >
                      <DeleteIcon className="delete-icon" />
                    </Button>
                  </TableCell>
                  <TableCell>{details?.regionId?.regionName}</TableCell>
                  <TableCell>{details?.clientEntityId?.entityName}</TableCell>
                  <TableCell>
                    <Link
                     to ={`/admin/add-or-update-regionBusinessDetail/update/${details.clientEntityRegionReportId}`}
                      // variant="contained"
                      onClick={() => addOrUpdateRegionBusinessDetails(details)}
                      className="table-row-background link-btn"
                    >
                      Edit
                    </Link>
                    {/* <Button
                      variant="contained"
                      onClick={() => addOrUpdateRegionBusinessDetails(details)}
                      className="table-row-background"
                    >
                      Edit
                    </Button> */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </div>
  );
};

export default RegionBusinessDetails;
